import { createContext, useContext, useEffect, useState } from "react";

const DiscreetContext = createContext({ discreet: false, toggle: () => {} });

export function DiscreetProvider({ children }) {
  const [discreet, setDiscreet] = useState(() => {
    try { return localStorage.getItem("ss_discreet") === "1"; } catch { return false; }
  });
  const toggle = () => setDiscreet((d) => !d);
  useEffect(() => {
    try { localStorage.setItem("ss_discreet", discreet ? "1" : "0"); } catch {}
    if (typeof document !== "undefined") {
      // Only override while discreet (Helmet owns page titles otherwise); restore a neutral title when switching back.
      if (discreet) document.title = "Dashboard";
      else if (document.title === "Dashboard") document.title = "Private relationship guidance | SugarSense";
    }
  }, [discreet]);
  return <DiscreetContext.Provider value={{ discreet, toggle }}>{children}</DiscreetContext.Provider>;
}

export const useDiscreet = () => useContext(DiscreetContext);
